import PropTypes from "prop-types";
import {
  ScatterChart as RCScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  LabelList,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

export const ScatterChart = ({
  data,
  chartProps,
  dotContent,
  cartesianGridProps,
  xAxisProps,
  yAxisProps,
  tooltipContent,
  labelContent,
}) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <RCScatterChart {...chartProps}>
        {cartesianGridProps && <CartesianGrid {...cartesianGridProps} />}

        {xAxisProps && <XAxis {...xAxisProps} />}
        {yAxisProps && <YAxis {...yAxisProps} />}

        {tooltipContent && (
          <Tooltip
            cursor={{ strokeDasharray: "5 5" }}
            content={tooltipContent}
          />
        )}
        <Scatter data={data} shape={dotContent}>
          <LabelList dataKey="name" fill="#FFFFFF" content={labelContent} />
        </Scatter>
      </RCScatterChart>
    </ResponsiveContainer>
  );
};

ScatterChart.propTypes = {
  data: PropTypes.array,
  chartProps: PropTypes.elementType,
  dotContent: PropTypes.elementType,
  cartesianGridProps: PropTypes.elementType,
  xAxisProps: PropTypes.elementType,
  yAxisProps: PropTypes.elementType,
  tooltipContent: PropTypes.elementType,
  labelContent: PropTypes.elementType,
};

ScatterChart.defaultProps = {
  data: [],
};
